import React, { useState, useEffect } from "react";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle,
} from "@/components/ui/dialog";
import { api } from "@/lib/api";
import { EVENT_LABELS } from "@/lib/constants";
import { formatDate } from "@/lib/format";
import { Circle } from "lucide-react";

export function ActivityDialog({ record, open, onOpenChange }) {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!open || !record) return;
    setLoading(true);
    api.get(`/events?entity_id=${record.id}`)
      .then((r) => setEvents(r.data))
      .catch(() => setEvents([]))
      .finally(() => setLoading(false));
  }, [open, record]);

  if (!record) return null;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="activity-dialog">
        <DialogHeader>
          <DialogTitle className="font-heading">{record.reference_code} · Activity</DialogTitle>
        </DialogHeader>
        {loading ? (
          <p className="text-sm text-ink-muted py-4">Loading…</p>
        ) : events.length === 0 ? (
          <p className="text-sm text-ink-muted py-4">No activity recorded yet.</p>
        ) : (
          <ol className="relative border-l border-border ml-2 mt-2 space-y-4 py-2">
            {[...events].reverse().map((e) => (
              <li key={e.id} className="ml-5" data-testid={`activity-${e.event_type}`}>
                <span className="absolute -left-[6px] mt-1.5 w-3 h-3 rounded-full bg-brandblue border-2 border-white" />
                <p className="text-sm font-medium text-midnight">{EVENT_LABELS[e.event_type] || e.event_type}</p>
                <p className="text-xs text-ink-muted">{formatDate(e.event_timestamp)}</p>
              </li>
            ))}
          </ol>
        )}
      </DialogContent>
    </Dialog>
  );
}
